import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Eye, Check } from "lucide-react";

export const PlanPreview = ({ projects, planFor, setPlanFor, plan }) => (
  <div className="rounded-xl border border-slate-200 bg-white p-5" data-testid="backup-plan-card">
    <div className="flex flex-wrap items-center gap-3">
      <Eye className="h-5 w-5 text-slate-500" />
      <div className="flex-1"><h2 className="text-base font-semibold text-slate-900">Preview backup plan</h2><p className="text-xs text-slate-500">Shows how an existing project's evidence is organised at the destination.</p></div>
      <Select value={planFor} onValueChange={setPlanFor}><SelectTrigger className="w-72" data-testid="backup-plan-project-select"><SelectValue placeholder="Choose a project…" /></SelectTrigger><SelectContent>{projects.map((p) => <SelectItem key={p.project_id} value={p.project_id}>{p.project_number} · {p.customer_name} / {p.brand}</SelectItem>)}</SelectContent></Select>
    </div>
    {plan && (
      <div className="mt-4 font-mono text-xs" data-testid="backup-plan-tree">
        <div className="text-slate-900 font-semibold">{plan.destination_display}/<span className="text-blue-700">{plan.root}</span>/</div>
        {plan.folders.map((f) => (
          <div key={f.code} className="ml-4 mt-1">
            <div className="text-slate-800">├─ {f.code}/ <span className="text-slate-400">({f.entries.length})</span></div>
            {f.entries.map((e, i) => <div key={i} className="ml-6 text-slate-500 flex items-center gap-1">│  {e.name}{e.status ? ` [${e.status}]` : ""}{e.synced && <Check className="h-3 w-3 text-emerald-600" />}</div>)}
          </div>
        ))}
        {plan.unmapped.length > 0 && <div className="ml-4 mt-1 text-amber-700">└─ _UNMAPPED/ ({plan.unmapped.length}) {plan.unmapped.map((u) => u.name).join(", ")}</div>}
        <p className="mt-3 font-sans text-slate-500">{plan.note}</p>
      </div>
    )}
  </div>
);
